import { useMemo } from 'react';
import { useParams as useWouterParams, useLocation as useWouterPathname, useSearchParams as useWouterSearchParams, } from 'wouter';
export const useSearchParams = () => {
    const [wouterSearchParams] = useWouterSearchParams();
    return useMemo(() => new URLSearchParams(wouterSearchParams.toString()), [wouterSearchParams]);
};
export const useParams = () => {
    const wouterParams = useWouterParams();
    return useMemo(() => ({ ...wouterParams }), [wouterParams]);
};
export const usePathname = () => {
    const [wouterPathname] = useWouterPathname();
    return wouterPathname;
};
//# sourceMappingURL=index.js.map